import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UIState {
  /** 侧边栏是否折叠 */
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
}

/** 全局 UI 状态（持久化到 localStorage） */
export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    }),
    { name: 'hibro-ui' },
  ),
)
